import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslatePipe } from '../../../pipes/translate.pipe';

/**
 * Confirm dialog shown when the user tries to leave an in-progress test
 * (SHARP / SENSE). Leaving discards everything done so far — nothing is saved
 * until the test completes. Resolves `true` to leave, `false` to stay.
 */
@Component({
  selector: 'app-exit-test-dialog',
  standalone: true,
  imports: [MatButtonModule, MatDialogModule, TranslatePipe],
  templateUrl: './exit-test-dialog.component.html',
  styleUrls: ['./exit-test-dialog.component.scss'],
})
export class ExitTestDialogComponent {
  constructor(public dialogRef: MatDialogRef<ExitTestDialogComponent>) {}
}
